import React, { useState } from 'react';
import { useVendorContext } from '../../context/VendorContext';
import './AddVendorForm.css';

const AddVendorForm = ({ onClose }) => {
  const [name, setName] = useState('');
  const { addVendor } = useVendorContext();

  const handleSubmit = async () => {
    if (!name.trim()) return;

    try {
      await addVendor(name);
      setName('');
      onClose();
    } catch (error) {
      console.error('Failed to add vendor:', error);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="add-vendor-form">
      <input
        type="text"
        placeholder="Vendor name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyPress={handleKeyPress}
        autoFocus
      />
      <div className="form-actions">
        <button onClick={handleSubmit} className="btn-primary">Add</button>
        <button onClick={onClose} className="btn-secondary">Cancel</button>
      </div>
    </div>
  );
};

export default AddVendorForm;